export namespace Models {
    /**
     * generic
     * key: string, value: any
    */
    export interface IKeyValue<T> {
        key: string;
        value: T;
    }

    /**
     * generic
     * key: string, value: data[]
    */
    export interface IDataSource<T> {
        key: string;
        data: T[];
    }

    /**
     * generic
    */
    export interface ILooseMapObj<T> {
        [key: string]: T;
    }

    export interface RoseGun {
        template: string;
        resparnter_id: number;
        yonghu_id: number;
        banner_url: string;
        cims_uid: string;
        website_title: string;
        website_status: boolean;
    }

    export interface IPropertyDetail {
        HouSchoolList: any[];
        active: boolean;
        agentCompanyAddress: string;
        agentCompanyName: string;
        agentCompanyTel: string;
        approxAge: string;
        attention: number;
        basements: any[];
        bedrooms: string;
        bedroomsPlus: string;
        brokerage: string;
        browseNumber: number;
        builtYear: string;
        business: any;
        buyInfo: any;
        city: any;
        community: any;
        condoFeatures: any;
        crossStreets: any;
        firstPay: any;
        fronting: any;
        fullAddress: any;
        garages: any;
        identifier: string;
        isRifo: any;
        latitude: any;
        listingCreatedTimestamp: any;
        listingType: any;
        longitude: any;
        managementFee: any;
        mlsNumber: any;
        monthPay: any;
        newBuildingArea: any;
        newLotArea: any;
        newRooms: any;
        newUsageArea: any;
        notTheFirstTax: any;
        occupyDate: any;
        openhouse: any;
        otherFeatures: any;
        otherFee: any;
        ownership: any;
        parkingSpaces: any;
        pictures: any;
        poolInfo: any;
        price: any;
        priceUnit: any;
        propertyType: any;
        realEstateBoardName: any;
        region: any;
        remarks: any;
        soldDate: any;
        soldPrice: any;
        storey: any;
        tax: any;
        theFirstTax: any;
        totalPay: any;
        utilityFeatures: any;
        utilityIncludes: any;
        virtualTour: any;
        washrooms: any;
        washroomsInfo: any;
        zoning: any;
        RifoTags?: string[];
    }

    export interface IWechatShareConfig {
        title: string;
        desc: string;
        link?: string;
        imgUrl?: string;
        success?: (res: any) => any;
    }

    export interface IBoostrapField {
        value: string;
        state?: string | null;
    }

    export interface IMapListSimpleFilters {
        filterSimplePrice: any;

        filterSimpleBeds: any;
        filterSimpleBaths: any;
        filterSimpleGarages: any;
        filterSimpleHomeTypes: any;

        filterSimpleListingTypes: any;
    }

    export function initMapListSimpleFilters(): IMapListSimpleFilters {
        return {
            filterSimplePrice: [0, 100],
            filterSimpleBeds: ['all'],
            filterSimpleBaths: ['all'],
            filterSimpleGarages: ['all'],
            filterSimpleHomeTypes: [],
            filterSimpleListingTypes: [],
        };
    }
}
